import React from "react";
import "./DilemaPop.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import gl from "../../images/glo.svg";
import { END_URL, IMG_URL } from "../../config";
import { useNavigate } from "react-router-dom";

function DilemaPop({ dilemma_popup ,onClose }) {

  const navigate = useNavigate();

  return (
    <div className="dilema-pop-cont">

      <div className="dilema-pop-div">

            <div className="dilema-pop-text">

                {/* <h3>
                  <span><img src="" alt="" /></span>
                  Pressure Brief
                  <span><img src="" alt="" /></span>
                </h3>

                <p>Before start , here's what you need to know</p> */}

                <div dangerouslySetInnerHTML={{__html:dilemma_popup?.dilemma_popup?.dilemma_start_popup_content }} />
                  
                <ul>
                    {dilemma_popup?.dilemma_popup_item?.map((item) => (
                      <li key={item.id}>
                        <div>
                          <img src={`${IMG_URL}/d0/${item.image}`} alt="" />
                        </div>

                        <span
                          dangerouslySetInnerHTML={{ __html: item.text }}
                        />
                      </li>
                    ))}
                </ul>

                {dilemma_popup?.dilemma_popup?.dilemma_start_button && (

                  <a className="continue-btn new-commom-btn" onClick={onClose} >

                      <span>{dilemma_popup?.dilemma_popup?.dilemma_start_button}</span>

                      <span class="righ-arr">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </span>
                  </a>
                )}
            </div>

            {dilemma_popup?.dilemma_popup?.dilemma_back_button && (

                <a  className="continue-btn new-commom-btn"  onClick={() => navigate(-1)} >

                  <span>{dilemma_popup?.dilemma_popup?.dilemma_back_button}</span>

                  <span class="righ-arr">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </span>
                </a>
            )}

      </div>

    </div>
  );
}

export default DilemaPop;
